import type { TourSpec } from "./types";

export const dashboardTour: TourSpec = {
  id: "dashboard",
  version: 1,
  buildSteps: (t) => [
    {
      target: '[data-tour="dashboard-greeting"]',
      title: t("dashboard.greeting.title"),
      content: t("dashboard.greeting.body"),
      placement: "bottom",
      skipBeacon: true,
    },
    {
      target: '[data-tour="dashboard-opportunities-kpi"]',
      title: t("dashboard.kpi.title"),
      content: t("dashboard.kpi.body"),
      placement: "bottom",
    },
    {
      target: '[data-tour="dashboard-top-opportunities"]',
      title: t("dashboard.topOpportunities.title"),
      content: t("dashboard.topOpportunities.body"),
      placement: "auto",
    },
    {
      target: '[data-tour="dashboard-snipe-alerts"]',
      title: t("dashboard.snipeAlerts.title"),
      content: t("dashboard.snipeAlerts.body"),
      placement: "auto",
    },
    {
      target: '[data-tour="dashboard-realm-stats"]',
      title: t("dashboard.realmStats.title"),
      content: t("dashboard.realmStats.body"),
      placement: "auto",
    },
    {
      target: '[data-tour="dashboard-quick-actions"]',
      title: t("dashboard.quickActions.title"),
      content: t("dashboard.quickActions.body"),
      placement: "top",
    },
  ],
};
